"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitFilterOption = void 0;
const mobx_1 = require("mobx");
const products_1 = require("@getgreenline/products");
class UnitFilterOption {
    constructor() {
        this.setUnit = (unit) => {
            this.unit = unit;
        };
        this.reset = () => {
            this.unit = undefined;
        };
        this.isMatching = (metaData) => {
            if (this.unit === undefined)
                return true;
            const unit = metaData[products_1.MetaDataModels.MetaDataReservedKeys.UNIT];
            return this.unit === unit;
        };
    }
}
exports.UnitFilterOption = UnitFilterOption;
__decorate([
    mobx_1.observable,
    __metadata("design:type", String)
], UnitFilterOption.prototype, "unit", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], UnitFilterOption.prototype, "setUnit", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], UnitFilterOption.prototype, "reset", void 0);
//# sourceMappingURL=UnitFilterOption.js.map